import { generateBridge } from "../Utility/GenerateBridge";


export type AdsBridgeAsync = {
    loadAd: (payload: IAdvertisementPlacement) => Promise<boolean>;
    showAd: (payload: IAdvertisementPlacement) => Promise<boolean>;
};
export interface IAdvertisementPlacement {
    id?: string;
    type: AdvertisementType;
}

export enum AdvertisementType {
    INTERSTITIAL = 'interstitial',
    REWARDED = 'rewarded',
}

export const Ads = generateBridge({
    name: 'Ads',
    sync: {},
    async: { loadAd: undefined, showAd: undefined },
    event: {},
});
